<template>
  <page-container>
    <template v-slot:page-fixed-header>
      <span class="text-h5 font-weight-bold ml-3 full-width page-header">{{
        $t("menu.stockAnalysis")
      }}</span>
      <v-spacer></v-spacer>
      <div style="height:40px;"/>
    </template>
    <template v-slot:page-content>
      <HoolderStockAnalysis />
    </template>
  </page-container>
</template>

<script>
import HoolderStockAnalysis from "@/components/stock/HoolderStockAnalysis.vue";
export default {
  name: "StockAnalysis",
  components: {
    HoolderStockAnalysis,
  },
  data() {
    return {};
  },
  computed: {
    getHeight() {
      return window.innerHeight - 145;
    },
  },
  methods: {},
  async mounted() {},
};
</script>

<style scoped>
::v-deep .container--fluid {
  padding: 0px !important;
}
.v-main {
  background: var(--v-Neutral-base) !important;
  padding-top: 105px !important;
}
</style>